import * as Constants from '../../utils/Constants';
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import {
  ManageCampaignGetDetail,
  RemoveFromManageCampaign,
  UpdateCampaignID,
  getDesignByID,
  UpdateCampaignOldDesign,
  AddToManageCampaign,
  generatePublicPreviewLink,
  revokePublicPreviewLink,
  getPublicPreviewLink,
  clearPublicPreviewLink,
} from '../../redux/actions';
import { GetManageColumns } from '../../redux/actions/Configuration/Configuration';
import { createColumnDef } from 'utils/agGridDefaults';
import React, { useEffect, useState, useMemo } from 'react';
import { claimOperations, componentsClaimKey } from '../../utils/Constants';
import { useDispatch, useSelector } from "react-redux";
import TableViewComponent from './TableViewComponent';
import ResultsGrid from './ResultsGrid';
import MasterDetailGrid from './MasterDetailGrid';
import AGGridWrapper from 'components/AGGrid/AGGridWrapper';
import DatePickerDropDown from "components/Shared/DatePickerDropDown";
import DesignUnpublishModal from "components/EmailDesigner/DesignLibrary/DesignUnpublishModal/DesignUnpublishModal";
import GridDataFormater from '../../utils/GridDataFormater';
import HelperFunctions from '../../utils/HelperFunctions';
import { Dialog, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { DraggableDialogContent } from "@/components/ui/draggable-dialog";
import { Button } from "@/components/ui/button";
import Select from "react-select";
import { trackPromise } from "react-promise-tracker";
import { withRouter } from '../../utils/withRouter';
import ActionButton from "./ActionButton/ActionButton";
import CampaignSelection from "./CampaignSelection/CampaignSelection";
import toast from '../../utils/toast';
import { FaCopy, FaCheck } from "react-icons/fa";


const sortByOptions = [
  { value: 'revenue.a', label: "Revenue: Ascending " },
  { value: 'revenue.d', label: "Revenue: Descending " },
  { value: 'playName.a', label: "Name: Ascending" },
  { value: 'playName.d', label: "Name: Descending " },
];

var currentday = new Date();
currentday.setHours(0, 0, 0, 0);
let _startDate = new Date(currentday.setMonth(currentday.getMonth() - 12));
let _endDate = new Date();
const DefaultPageSize = 10;

const ManageCampaigns = (props) => {
  const dispatch = useDispatch();
  const { clientUserClaims } = useSelector((state) => state.common);
  const [clientId, setClientId] = useState(HelperFunctions.getCookie("selectedClientId"));
  const { manage_campaign_detail } = useSelector((state) => state.marketingPlayReports);
  const { designByID, publicPreviewLink, isGeneratingLink, isRevokingLink } = useSelector((state) => state.emailDesigner);
  const { user_information } = useSelector((state) => state.common);
  const { manage_columns } = useSelector((state) => state.common);
  const [isESPRole, setIsESPRole] = useState(false);
  const masterDetailGridRef = React.useRef();
  const tableViewRef = React.useRef();
  const [startDate, setStartDate] = useState(_startDate.toJSON());
  const [endDate, setEndDate] = useState(_endDate.toJSON());

  // Arrow settings removed - Master/Detail handles expansion automatically
  const [manageCampaignSummary, setManageCampaignSummary] = useState([]);
  const [manageCampaignDetail, setManageCampaignDetail] = useState([]);
  const [menuSetting, setMenuSetting] = useState(0);
  const [totalCategorizedRevenue, setTotalCategorizedRevenue] = useState(0);
  const [totalAdhocRevenue, setTotalAdhocRevenue] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [filterSummary, setFilterSummary] = useState(null);
  const [isRemoveEmailPopupShow, setIsRemoveEmailPopupShow] = useState(false);
  const [selectedDesign, setSelectedDesign] = useState(null);
  const [isUnPublishPopupShow, setIsUnPublishPopupShow] = useState(false);
  const [isAdhoc, setIsAdhoc] = useState(false);
  const [isPreviewPopupShow, setIsPreviewPopupShow] = useState(false);
  const [previewHTML, setPreviewHTML] = useState(false);
  const [selectedAction, setSelectedAction] = useState("");
  const [filterDetails, setFilterDetails] = useState(null);
  const [effected, setEffected] = useState(false);
  const [includeNoRevenue, setIncludeNoRevenue] = useState(true);
  const [isSelectCampaignPopupShow, setIsSelectCampaignPopupShow] = useState(false);
  const [selectedCampaignId, setSelectedCampaignId] = useState(0);
  const [isTableView, setIsTableView] = useState(false);
  const [sortValue, setSortValue] = useState("playName.a");
  const [isExpanded, setIsExpanded] = useState(false);
  const [arrowSettingAll, setArrowSettingAll] = useState(false);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [showRevokeConfirm, setShowRevokeConfirm] = useState(false);
  const [columnsChanged, setColumnsChanged] = useState(false);
  const [tableViewKey, setTableViewKey] = useState(0);

  // Wrapper function that sets the columnsChanged flag when columns are updated
  const handleSetColumnDefs = (newColumnDefs) => {
    setColumnDefs(newColumnDefs);
    setColumnsChanged(true);
  };
  //const [defaultCampaigntype, setDefaultCampaigntype] = useState({ value: 1, label: "All" });
  //const [defaultStatusBy, setDefaultStatusBy] = useState({ value: 1, label: "All" });

  const populateTitle = (params) => {

    if (!params?.data) {
      return null;
    }
    var html = (
      <div className="campaing-title-status">
        <div className="d-flex flex-column">
          <span className="campaign-title font-weight-bold">{params.data.name}</span>
          <span className={"campaign-status " + (params.data.status === Constants.emailStatus.ListSend ? "sent" : params.data.status?.toLowerCase())}><span className="status-dot mr-1"></span>{params.data.status === Constants.emailStatus.ListSend ? <>Sent<i className="fa fa-bolt"></i></> : params.data.status}</span>
        </div>
      </div>
    );
    return html;
  };

  const populateThumbnail = (params) => {

    if (!params?.data) {
      return null;
    }
    const { data } = params;
    let endpoint = null;
    let id = '';
    let isDemoClient = Constants.DEMO_CLIENT_IDS.includes(clientId);
    if (data.templateID) {
      endpoint = 'shared/GetThumbnail';
      id = `&id=${data.templateID}`;
    } else if (isDemoClient) {
      endpoint = 'shared/GetDemoThumbnail';
    }
    const thumbnail = `${Constants.VNEXT_BASE_URL}${endpoint}?clientId=${clientId}&module=templates${id}`;
    if (endpoint === null) {
      return null; // No suitable endpoint found
    }



    const handleClick = () => {
      preview(data);
    };

    return (
      <img
        className="w-100 h-100 cursor-pointer"
        onClick={isDemoClient ? null : handleClick}
        src={thumbnail}
        alt="tmp1"
      />
    );
  };

  const populateCampaignCategory = (params) => {
    if (!params?.data) {
      return null;
    }

    var html = (
      <div className="campaing-category">
        <div>
          <span className="campaign text-break d-block">{params.data.playName ? params.data.playName : "Uncategorized"}</span>
        </div>
      </div>
    );

    return html;
  };

  const populateLastSentDate = (params) => {
    if (!params?.data) {
      return null;
    }

    if (params.data.lastSentDate) {
      return (<span dangerouslySetInnerHTML={{ __html: GridDataFormater.formatDateWithTimeWithLineBreak(params.data.lastSentDate) }} />)
    }
    return null;
  }

  const populateNextSendDate = (params) => {

    if (!params?.data) {
      return null;
    }
    if (params.data.nextSendDate) {
      return (<span dangerouslySetInnerHTML={{ __html: GridDataFormater.formatDateWithTimeWithLineBreak(params.data.nextSendDate) }} />)
    }
    else {
      return null;
    }
  }

  const populateEndDate = (params) => {
    if (!params?.data) {
      return null;
    }
    if (params.data.endDate) {
      return (<span dangerouslySetInnerHTML={{ __html: GridDataFormater.vNextformatDateTimefromUTC({ value: params.data.endDate }) }} />)
    }
    else {
      return null;
    }
  }

  const actionChanged = async (detail, params) => {

    if (params?.data) {
      return null;
    }

    if (params.target.value === "Edit") {
    }
    else if (params.target.value === "1") {
      viewReport(detail);
    }
    else if (params.target.value === "2") {
      await handleUnpublishDesign(detail, false);
    }
    else if (params.target.value === "3") {
      toggleCampaignSelection(detail);
    }
    else if (params.target.value == "4") {
      preview(detail);
    }
    else if (params.target.value == "5") {
      draftDesignToSendWizard(detail);
    }
  };

  const populateActions = (params) => {
    const data = params?.data;

    if (!params?.data) {
      return null;
    }

    return (
      <div id="action-wrap">
        <select
          className="browser-default actionSelect form-control"
          onChange={actionChanged.bind(this, data)}
          value={selectedAction}
        >
          <option value="" title="" disabled>
            &#xf142;
          </option>

          {data?.status === Constants.emailStatus.Draft && data?.emailTemplateEnabled ? (
            <option value="5" title="Continue">
              Continue
            </option>
          ) : null}

          {HelperFunctions.validateClientUserClaims(
            [componentsClaimKey.Designs, componentsClaimKey.MarketingPlayConfiguration],
            claimOperations.Update,
            clientUserClaims
          ) ? (
            <option value="3" title="Move">Move &nbsp;&nbsp;</option>
          ) : null}

          {data?.status &&
            [
              Constants.emailStatus.Recurring,
              Constants.emailStatus.Sent,
              Constants.emailStatus.Triggered,
              Constants.emailStatus.ListSend,
              Constants.emailStatus.Paused,
            ].includes(data.status) ? (
            <option value="1" title="View Report">
              View Report
            </option>
          ) : null}

          {HelperFunctions.validateClientUserClaims(
            [componentsClaimKey.Designs, componentsClaimKey.MarketingPlayConfiguration],
            claimOperations.Update,
            clientUserClaims
          ) &&
            data?.status &&
            data.status === Constants.emailStatus.Recurring ? (
            <option value="2" title="Unpublish">
              Unpublish
            </option>
          ) : null}

          {data?.templateID ? (
            <option value="4" title="Preview">
              Preview
            </option>
          ) : null}
        </select>
      </div>
    );
  };


  // const populateActions = (params) => {
  //   return (
  //     <div id="action-wrap">
  //       <select
  //         className="browser-default actionSelect form-control"
  //         onChange={actionChanged.bind(this,params.data)}
  //         value={selectedAction}
  //       >
  //         <option value="" title="" disabled>
  //           &#xf142;
  //         </option>
  //         {/* <option value="3" title="Move">
  //             Move &nbsp;&nbsp;
  //           </option> */}
  //         {params.data.status && 
  //           params.data.status === Constants.emailStatus.Draft && 
  //           params.data.emailTemplateEnabled ?
  //           <option value="5" title="Continue">
  //             Continue
  //           </option> : null
  //         }
  //         {
  //           HelperFunctions.validateClientUserClaims(
  //             [componentsClaimKey.Designs,componentsClaimKey.MarketingPlayConfiguration],
  //             claimOperations.Update,
  //             clientUserClaims
  //           ) ?
  //           <option value="3" title="Move">
  //             Move &nbsp;&nbsp;
  //           </option>:null
  //         }
  //         {params.data.status && 
  //           (params.data.status === Constants.emailStatus.Recurring || 
  //             params.data.status === Constants.emailStatus.Sent || 
  //             params.data.status === Constants.emailStatus.Triggered ||
  //             params.data.status === Constants.emailStatus.ListSend ||
  //             params.data.status === Constants.emailStatus.Paused) ?
  //           <option value="1" title="View Report">
  //             View Report
  //           </option> : null
  //         }
  //         {HelperFunctions.validateClientUserClaims(
  //             [componentsClaimKey.Designs,componentsClaimKey.MarketingPlayConfiguration],
  //             claimOperations.Update,
  //             clientUserClaims
  //           ) && params.data.status 
  //           && (params.data.status === Constants.emailStatus.Recurring || 
  //               params.data.status === Constants.emailStatus.Scheduled) ?
  //           (
  //             <option value="2" title="Unpublish">
  //               Unpublish
  //             </option>
  //           ) : null}
  //         {params.data.templateID ? 
  //         <option value="4" title="Preview">
  //           Preview
  //         </option>:null}
  //       </select>
  //     </div>
  //   );
  // };

  const populateRevenue = (params) => {
    const data = params?.data;

    if (!params?.data) {
      return null;
    }
    return (
      HelperFunctions.formateNumberbyCommas(params.data.revenue, true, 0, true)
    );
  };

  const columnDefsOrignal = [
    {
      headerName: "",
      hide: false,
      cellStyle: { textAlign: "center" },
      width: 50,
      lockPosition: true,
      cellRenderer: populateActions,
      pinned: 'left',
      suppressMovable: true,
      customOrder: 0
    },
    createColumnDef({
      headerName: "Title",
      field: "name",
      fieldType: "text",
      hide: false,
      minWidth : 3,
      width: 300,
      maxWidth: 2000,
      lockPosition: true,
      cellRenderer: populateTitle,
      pinned: 'left',
      suppressMovable: true,
      customOrder: 1
    }),
    createColumnDef({
      headerName: "Thumbnail",
      field: "thumb",
      fieldType: "text",
      hide: false,
      width: 120, // Fixed width to accommodate "Thumbnail" header text
      cellStyle: { textAlign: "center" },
      cellRenderer: populateThumbnail,
      suppressMovable: true,
      customOrder: 2,
      sortable: false,
      filter: false,
    }),
    createColumnDef({
      headerName: "Subject Line",
      field: "subject",
      fieldType: "text",
      hide: false,
      wrapText: true,
      cellStyle: { wordBreak: "break-word" },
      minWidth: 200,
      maxWidth: 500,
      suppressMovable: true,
      customOrder: 3
    }),
    createColumnDef({
      headerName: "Campaign Category",
      field: "playName",
      fieldType: "text",
      hide: true,
      maxWidth: 250,
      cellRenderer: populateCampaignCategory,
      wrapText: true,
      suppressMovable: true,
      customOrder: 4
    }),
    createColumnDef({
      headerName: "Last Sent",
      field: "lastSentDate",
      fieldType: "date",
      hide: false,
      cellRenderer: populateLastSentDate,
      initialSort: 'desc',
      suppressMovable: true,
      customOrder: 5
    }),
    createColumnDef({
      headerName: "Recurrence",
      field: "recurrence",
      fieldType: "text",
      hide: true,
      suppressMovable: true,
      customOrder: 6
    }),
    createColumnDef({
      headerName: "Recurrence Details",
      field: "recurrenceDetails",
      fieldType: "text",
      hide: true,
      suppressMovable: true,
      customOrder: 7
    }),
    createColumnDef({
      headerName: "Revenue",
      field: "revenue",
      fieldType: "number",
      hide: false,
      cellClass: 'ag-right-aligned-cell pr-2',
      cellRenderer: populateRevenue,
      suppressMovable: true,
      customOrder: 8
    }),
    createColumnDef({
      headerName: "Total Sent",
      field: "totalSent",
      fieldType: "number",
      hide: false,
      cellClass: 'ag-right-aligned-cell pr-2',
      valueFormatter: GridDataFormater.formatNumber,
      suppressMovable: true,
      customOrder: 9
    }),
    createColumnDef({
      headerName: "Delivered Rate",
      field: "deliveredRate",
      fieldType: "number",
      hide: true,
      cellClass: 'ag-right-aligned-cell pr-2',
      valueFormatter: GridDataFormater.formatPercentage,
      suppressMovable: true,
      customOrder: 10
    }),
    createColumnDef({
      headerName: "Open Rate",
      field: "openRate",
      fieldType: "number",
      hide: false,
      cellClass: 'ag-right-aligned-cell pr-2',
      valueFormatter: GridDataFormater.formatPercentage,
      suppressMovable: true,
      customOrder: 11
    }),
    createColumnDef({
      headerName: "Click Rate",
      field: "clickRate",
      fieldType: "number",
      hide: false,
      cellClass: 'ag-right-aligned-cell pr-2',
      valueFormatter: GridDataFormater.formatPercentage,
      suppressMovable: true,
      customOrder: 12
    }),
    createColumnDef({
      headerName: "Schedule Type",
      field: "type",
      fieldType: "text",
      hide: false,
      suppressMovable: true,
      customOrder: 13
    }),
    createColumnDef({
      headerName: "Source",
      field: "source",
      fieldType: "text",
      hide: true,
      wrapText: true,
      maxWidth: 250,
      suppressMovable: true,
      customOrder: 14
    }),
    createColumnDef({
      headerName: "Next Send Date",
      field: "nextSendDate",
      fieldType: "date",
      hide: true,
      cellRenderer: populateNextSendDate,
      suppressMovable: true,
      customOrder: 15
    }),
    createColumnDef({
      headerName: "End Date",
      field: "endDate",
      fieldType: "date",
      hide: true,
      cellRenderer: populateEndDate,
      suppressMovable: true,
      customOrder: 16
    }),
    createColumnDef({
      headerName: "Marketing Play ID",
      field: "marketingPlayId",
      fieldType: "text",
      hide: true,
      suppressMovable: true,
      customOrder: 17
    }),
    createColumnDef({
      headerName: "Delivered",
      field: "totalDelivered",
      fieldType: "number",
      hide: true,
      cellClass: 'ag-right-aligned-cell pr-2',
      valueFormatter: GridDataFormater.formatNumber,
      suppressMovable: true,
      customOrder: 18
    }),
    createColumnDef({
      headerName: "Opens",
      field: "opened",
      fieldType: "number",
      hide: true,
      cellClass: 'ag-right-aligned-cell pr-2',
      valueFormatter: GridDataFormater.formatNumber,
      suppressMovable: true,
      customOrder: 19
    }),
    createColumnDef({
      headerName: "Clicks",
      field: "clicked",
      fieldType: "number",
      hide: true,
      cellClass: 'ag-right-aligned-cell pr-2',
      valueFormatter: GridDataFormater.formatNumber,
      suppressMovable: true,
      customOrder: 20
    }),
    createColumnDef({
      headerName: "Unsubscribe Rate",
      field: "unsubscribeRate",
      fieldType: "number",
      hide: true,
      cellClass: 'ag-right-aligned-cell pr-2',
      valueFormatter: GridDataFormater.formatPercentage,
      suppressMovable: true,
      customOrder: 21
    }),
    createColumnDef({
      headerName: "Unsubscribes",
      field: "unsubscribed",
      fieldType: "number",
      hide: true,
      cellClass: 'ag-right-aligned-cell pr-2',
      valueFormatter: GridDataFormater.formatNumber,
      suppressMovable: true,
      customOrder: 22
    }),
    createColumnDef({
      headerName: "Bounce Rate",
      field: "bounceRate",
      fieldType: "number",
      hide: true,
      cellClass: 'ag-right-aligned-cell pr-2',
      valueFormatter: GridDataFormater.formatPercentage,
      suppressMovable: true,
      customOrder: 23
    }),
    createColumnDef({
      headerName: "Bounces",
      field: "bounced",
      fieldType: "number",
      hide: true,
      cellClass: 'ag-right-aligned-cell pr-2',
      valueFormatter: GridDataFormater.formatNumber,
      suppressMovable: true,
      customOrder: 24
    }),
    createColumnDef({
      headerName: "Template ID",
      field: "templateID",
      fieldType: "text",
      hide: true,
      suppressMovable: true,
      customOrder: 25
    }),
  ];

  const [columnDefs, setColumnDefs] = useState(columnDefsOrignal);
  // const [columnDefsTableView, setColumnDefsTableView] = useState([])

  useEffect(() => {
    trackPromise(dispatch(ManageCampaignGetDetail(startDate, endDate, clientId)));

  }, [clientId, startDate, endDate]);

  useEffect(() => {
    if (designByID && designByID.html) {
      setPreviewHTML(designByID.html);
    }
  }, [designByID]);

  useEffect(() => {
    if (manageCampaignSummary?.length > 0) {
      applySortByForSummary({ value: sortValue });
    }
  }, [sortValue, manageCampaignSummary])

  useEffect(() => {
    var campaignSummary = manage_campaign_detail?.summary?.sort((a, b) => {
      if (a.playName?.toLowerCase() > b.playName?.toLowerCase()) {
        return 1;
      }
      else if (a.playName?.toLowerCase() < b.playName?.toLowerCase()) {
        return -1;
      }
      else {
        return a.subtitle?.toLowerCase() > b.subtitle?.toLowerCase() ? 1 : -1;
      }
    });

    // Calculate revenue for each campaign summary
    campaignSummary?.forEach((c) => {
      let filteredDetail = manage_campaign_detail?.details?.filter((a) => {
        return a.marketingPlayId === c.marketingPlayId
      });
      let revenue = 0;
      filteredDetail.forEach((f) => {
        revenue = revenue + f.revenue
      })
      c.revenue = revenue;
    });

    // Always create uncategorized summary entry first, even if empty
    const uncategorizedCampaigns = manage_campaign_detail?.details?.filter((detail) =>
      detail.uncategorized === 1 || !detail.marketingPlayId
    ) || [];

    const uncategorizedRevenue = uncategorizedCampaigns.reduce((total, campaign) =>
      total + (campaign.revenue || 0), 0
    );

    // Always create uncategorized summary - it will be filtered out later if no campaigns
    const uncategorizedSummary = {
      marketingPlayId: null, // No marketing play ID for uncategorized
      playName: 'Uncategorized',
      playSubtitle: null,
      playIcon: 'fa-regular fa-file-lines',
      playCssClass: 'uncategorized',
      uncategorized: true,
      revenue: uncategorizedRevenue,
      hasUncategorizedCampaigns: uncategorizedCampaigns.length > 0
    };

    // Always add uncategorized summary to the beginning
    campaignSummary = [uncategorizedSummary, ...(campaignSummary || [])];

    setManageCampaignSummary(campaignSummary);
    setManageCampaignDetail(manage_campaign_detail?.details);

    // Calculate totals
    var _totalRevenue = 0;
    var _adhocRevenue = 0;
    manage_campaign_detail?.details?.forEach((element) => {
      if (!isNaN(element.revenue)) {
        if (element.uncategorized === 1) {
          _adhocRevenue = _adhocRevenue + element.revenue;
        } else {
          _totalRevenue = _totalRevenue + element.revenue;
        }

      }
    });
    setTotalCategorizedRevenue(_totalRevenue);
    setTotalAdhocRevenue(_adhocRevenue);
  }, [manage_campaign_detail]);


  // Use useMemo to stabilize ESP role calculation
  const isESPRoleComputed = useMemo(() => {
    if (user_information && user_information.roles && Array.isArray(user_information.roles)) {
      // Simple and robust check for "Email" role
      const emailRole = user_information.roles.includes("Email");
      return emailRole;
    }
    return false;
  }, [user_information?.roles]); // Only depend on roles, not entire user_information

  // Update isESPRole state only when computed value changes
  useEffect(() => {
    if (isESPRoleComputed !== isESPRole) {
      setIsESPRole(isESPRoleComputed);
    }
  }, [isESPRoleComputed, isESPRole]);

  // Check for existing public preview link when modal opens
  useEffect(() => {
    if (isPreviewPopupShow && selectedDesign?.templateID) {
      dispatch(getPublicPreviewLink(clientId, selectedDesign.templateID));
    }
  }, [isPreviewPopupShow, selectedDesign, dispatch, clientId]);

  // Clear public preview link when modal closes
  useEffect(() => {
    if (!isPreviewPopupShow) {
      dispatch(clearPublicPreviewLink());
      setShowRevokeConfirm(false);
    }
  }, [isPreviewPopupShow, dispatch]);

  // Monitor manage_columns changes to detect when columns are saved
  useEffect(() => {
    if (manage_columns && manage_columns.data) {
      setColumnsChanged(true);
    }
  }, [manage_columns]);

  // Refresh column defs when clientUserClaims loads so populateActions picks up the correct claims
  useEffect(() => {
    if (clientUserClaims && clientUserClaims.length > 0) {
      setColumnDefs([...columnDefsOrignal]);
    }
  }, [clientUserClaims]); // eslint-disable-line react-hooks/exhaustive-deps

  const toggleRemoveEmailPopup = () => {
    setIsRemoveEmailPopupShow(!isRemoveEmailPopupShow);
  }


  const handleRemoveDesign = (isAdhoc = false) => {
    setIsAdhoc(isAdhoc);
    toggleRemoveEmailPopup();
  }

  const toggleUnPublishPopup = () => {
    setIsUnPublishPopupShow(!isUnPublishPopupShow);
  }

  const handleUnpublishDesign = (detail, isAdhoc = false) => {
    setSelectedDesign(detail);
    setIsAdhoc(isAdhoc);
    toggleUnPublishPopup();
  }

  const handleFilterChangeHandler = (startDate, endDate, all) => {
    if (startDate && endDate) {
      setStartDate(startDate.toJSON());
      setEndDate(endDate.toJSON());
    } else {
      setStartDate(null);
      setEndDate(null);
    }
  };


  // Arrow handling removed - Master/Detail grids handle expansion/collapse automatically

  const handleSummaryMenueDisplay = (id) => {
    if (menuSetting == id) {
      setMenuSetting(0);
    } else {
      setMenuSetting(id);
    }
  };

  const searchHandleChange = (e) => {
    setSearchText(e.target.value);
  };

  const draftDesignToSendWizard = (selectedTemplate) => {
    const wizardPayload = {
      campaignId: selectedTemplate.marketingPlayId,
      oldDesignId: selectedTemplate.templateID
    };
    trackPromise(dispatch(UpdateCampaignOldDesign(wizardPayload)).then(() => {
      props.router.navigate("/EmailDesigner/SendEmail/" + selectedTemplate.templateID + "/" + clientId);
    }));
  };

  const viewReport = (selectedTemplate) => {
    props.router.navigate("/EmailDesigner/CampaignReports/" + selectedTemplate.templateID + "/" + clientId);
  };

  const campaignSelection = (marketingPlayId = 0) => {
    if (marketingPlayId === 0) {
      props.router.navigate("/ChooseCampaign");
    }
    else {
      trackPromise(dispatch(UpdateCampaignID(marketingPlayId)).then(() => {
        props.router.navigate("/ChooseCampaign");
      }));
    }
  };

  const applySortByForSummary = (e) => {
    var selectedOption = e.value.split(".");
    var attribute = selectedOption[0];
    var sorting = selectedOption[1] == "d";

    if (attribute == "revenue") {
      manageCampaignSummary.sort(function (a, b) {
        if (sorting) {
          return b[attribute] - a[attribute]
        } else {
          return a[attribute] - b[attribute]
        }
      });
    }
    else {
      manageCampaignSummary.sort(function (a, b) {
        let x = '', y = '';
        if (sorting) {
          x = b[attribute].toLowerCase();
          y = a[attribute].toLowerCase();
        } else {
          x = a[attribute].toLowerCase();
          y = b[attribute].toLowerCase();
        }
        if (x < y) {
          return -1;
        }
        else if (x > y) {
          return 1;
        }
        else {
          return 0;
        }
      });
    }
    setManageCampaignSummary(manageCampaignSummary);
    setEffected(!effected);
  }

  const onChangeIncludeNoRevenue = (e) => {
    setIncludeNoRevenue(!includeNoRevenue);
  }

  const onRemoveEmailSubmit = () => {
    trackPromise(
      dispatch(RemoveFromManageCampaign(
        clientId,
        selectedDesign.marketingPlayId,
        selectedDesign.templateID,
        selectedDesign.name,
        selectedDesign.subject,
      ))
        .then(() => {
          trackPromise(dispatch(ManageCampaignGetDetail(startDate, endDate, clientId, isAdhoc)));
        })
    );
  };

  const setSelectedTabDetail = (tabName) => {
    setSearchText("");
    
    // Always call API to refresh column data on tab switch
    dispatch(GetManageColumns(clientId, Constants.MANAGE_COLUMN_ENTITIES.ManageCampaigns))
      .then(() => {
        // Refresh the grids after column data is updated
        setTimeout(() => {
          if (tabName === 'Results' && masterDetailGridRef.current) {
            masterDetailGridRef.current.refreshDetailGrids();
          } else if (tabName === 'TableView') {
            setTableViewKey(prev => prev + 1); // Force re-mount of TableViewComponent
            
            // Also try the refresh method as backup
            setTimeout(() => {
              if (tableViewRef.current) {
                tableViewRef.current.refreshColumns();
              }
            }, 100);
          }
        }, 200); // Small delay to ensure Redux state is updated
        
        setColumnsChanged(false); // Reset the flag
      })
      .catch((error) => {
        console.error('ManageCampaigns: Error refreshing column data:', error);
      });

    // Original logic (commented out for testing)
    // if (columnsChanged) {
    //   console.log('ManageCampaigns: Columns were changed, fetching updated column data...');
    //   dispatch(GetManageColumns(clientId, Constants.MANAGE_COLUMN_ENTITIES.ManageCampaigns))
    //     .then(() => {
    //       console.log('ManageCampaigns: Column data refreshed from server');
    //       setColumnsChanged(false); // Reset the flag
    //     })
    //     .catch((error) => {
    //       console.error('ManageCampaigns: Error refreshing column data:', error);
    //     });
    // } else {
    //   console.log('ManageCampaigns: columnsChanged is false, not calling API');
    // }
  };

  const togglePreview = () => {
    setIsPreviewPopupShow(!isPreviewPopupShow);
  };

  const preview = (design) => {
    setSelectedDesign(design);
    trackPromise(
      dispatch(getDesignByID(clientId, design.templateID)
      ).then(() => {
        togglePreview();
      })
    );
  }

  const generatePublicPreviewLinkHandler = async (designId) => {
    const result = await dispatch(generatePublicPreviewLink(clientId, designId));
    if (result.success) {
      toast.success("Preview link generated successfully");
      setShowRevokeConfirm(false);
    } else {
      toast.error(result.error || "Failed to generate preview link");
    }
  };

  const revokePublicPreviewLinkHandler = async () => {
    if (!showRevokeConfirm) {
      setShowRevokeConfirm(true);
      return;
    }

    const result = await dispatch(revokePublicPreviewLink(clientId, selectedDesign.templateID));

    if (result.success) {
      toast.success(result.message || "Preview link revoked successfully");
      setShowRevokeConfirm(false);
    } else {
      toast.error(result.error || "Failed to revoke preview link");
    }
  };

  const copyPreviewLink = () => {
    navigator.clipboard
      .writeText(publicPreviewLink)
      .then(() => {
        toast.success("Link copied to clipboard");
      })
      .catch(() => {
        // Fallback for older browsers
        const textarea = document.createElement("textarea");
        textarea.value = publicPreviewLink;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        toast.success("Link copied to clipboard");
      });
  };

  const toggleCampaignSelection = (detail) => {
    setSelectedDesign(detail);
    setSelectedCampaignId(0);
    setIsSelectCampaignPopupShow(!isSelectCampaignPopupShow);
  };

  const handleSelectedCampaignId = (id) => {
    setSelectedCampaignId(id);
  };

  const onSelectCampaign = async (e) => {
    if (selectedCampaignId > 0) {
      trackPromise(
        dispatch(AddToManageCampaign(
          clientId,
          selectedCampaignId,
          selectedDesign.templateID,
          selectedDesign.name,
          selectedDesign.subject,
        ))
          .then(() => {
            trackPromise(dispatch(ManageCampaignGetDetail(startDate, endDate, clientId)));
            toggleCampaignSelection();
            setSelectedCampaignId(0);
          })
      );
    }
    else {
      onRemoveEmailSubmit();
      toggleCampaignSelection();
      setSelectedCampaignId(0);
    }
  };

  const handleExpandCollapseToggle = () => {
    if (isExpanded) {
      masterDetailGridRef.current?.collapseAll();
      setIsExpanded(false);
      setArrowSettingAll(false);
    } else {
      masterDetailGridRef.current?.expandAll();
      setIsExpanded(true);
      setArrowSettingAll(true);
    }
  };

  // Master/Detail grid replaces the accordion-style layout

  // var cardWithDetails = manageCampaignSummary &&
  // manageCampaignSummary?.filter(a => 
  //   (
  //     (filterSummary == null ||  (a.playName?.toLowerCase() == filterSummary?.filterText.toLowerCase() && filterSummary?.filterType == 1)) &&
  //     (includeNoRevenue || a.revenue > 0)
  //   )).length > 0 ? (
  //     <>
  //       <Card className="sticky">

  //         <Accordion.Button as={Card.Header} className="mt-1">
  //         <div className='accordion-header'>
  //           <div className='row w-100 g-0'>
  //           <div className="chevrons-col col-1"></div>
  //           <div
  //             className="col-6 m-0 text-left campaign-name"
  //             onClick={() => {
  //               sortValue === "playName.a"
  //                 ? setSortValue("playName.d")
  //                 : setSortValue("playName.a");
  //             }}
  //           >
  //             <h6 className="d-inline-block cursor-pointer mr-2">
  //               Campaign Name
  //             </h6>
  //             {(sortValue === "playName.a" ) && (
  //               <span className="fa fa-arrow-up cursor-pointer"></span>
  //             )}
  //              {(sortValue === "playName.d" ) && (
  //               <span className="fa fa-arrow-down cursor-pointer"></span>
  //             )}
  //           </div>
  //           <div
  //             className={
  //               isESPRole ? "col-3 text-right" : "col-5 text-right"
  //             }
  //             onClick={() => {
  //               sortValue === "revenue.a"
  //                 ? setSortValue("revenue.d")
  //                 : setSortValue("revenue.a");
  //             }}
  //           >
  //             <h6 className="d-inline-block cursor-pointer mr-2">
  //               Total Revenue
  //             </h6>
  //             {(sortValue === "revenue.a" ) && (
  //               <span className="fa fa-arrow-up cursor-pointer"></span>
  //             )}
  //              {(sortValue === "revenue.d" ) && (
  //               <span className="fa fa-arrow-down cursor-pointer"></span>
  //             )}
  //           </div>
  //           {isESPRole && (
  //             <div className="col-2 text-right"><h6 className="d-inline-block">Action</h6></div>
  //           )}
  //           </div>
  //         </div>
  //         </Accordion.Button>

  //       </Card>
  //       {manageCampaignSummary?.filter(a => ((includeNoRevenue || a.revenue > 0) && !a.marketingPlayId))?.map((obj, index) => {
  //         // setArrowSettingAll(false);
  //         var filteredDetail = manage_campaign_detail && manage_campaign_detail?.details?.filter(a=> 
  //           (filterDetails==null ||  (a.status?.toLowerCase()==filterDetails?.filterText.toLowerCase() && filterDetails?.filterType==2)) && 
  //           a.marketingPlayId == obj.marketingPlayId  && 
  //           ((searchText ==null && searchText=='') || a.name?.toLowerCase().includes(searchText.toLowerCase())) &&
  //           (includeNoRevenue || a.revenue > 0)
  //           );
  //         if((searchText && filteredDetail.length) || !searchText) {
  //           arrowSetting[obj.marketingPlayId] = !!arrowSetting[obj.marketingPlayId];
  //           return ( 
  //           <>
  //             <Card>
  //             <Accordion.Button as={Card.Header} className={`${arrowSetting[obj.marketingPlayId] ? 'active' : ''}`} eventKey={obj.marketingPlayId}>
  //               <div className='accordion-header' onClick={() => { arrowHandling(obj.marketingPlayId) }}>
  //                 <div className='row w-100 g-0'>
  //                   <div className="chevrons-col col-1">                      
  //                       <div className='arrows pl-2'>
  //                         <span><i className={`fa fa-angle-${arrowSetting[obj.marketingPlayId] ? 'up' : 'down'}`}></i></span>
  //                       </div>                      
  //                   </div>
  //                   <div className="col-6">
  //                     <div className={'d-flex campaign-info ' + (obj.uncategorized ? 'uncategorized' : obj.playCssClass)}>
  //                       <div className='icon'>
  //                         <i className={obj.uncategorized ? 'fa-regular fa-file-lines m-auto' : obj.playIcon + ' m-auto'}></i>
  //                       </div>
  //                       <div className="titles ml-2">
  //                         <div className='secondary-title'>
  //                           {obj.playName} 
  //                           {obj.playSubtitle && obj.playSubtitle?.toLowerCase() !== "uncategorized" && (
  //                             <span> - <strong>{obj.playSubtitle}</strong></span>
  //                           )}
  //                         </div>
  //                         {/* <div className='primary-title'>
  //                           {obj.subtitle}
  //                         </div> */}
  //                       </div>
  //                     </div>
  //                   </div>

  //                   <div className={isESPRole ? "col-3" : "col-5"}>
  //                     <div className="c-revenue text-right">
  //                       {/* {index === 0 && (<div className='total-reven-heading position-absolute secondary-title numeric-data text-muted'>
  //                         Total Revenue
  //                       </div>)} */}
  //                       <div className='primary-title green'>
  //                         {HelperFunctions.formateNumberbyCommas(obj.revenue, true, 0, true)}
  //                       </div>
  //                     </div>
  //                   </div>
  //                   {isESPRole && <ActionButton handleSummaryMenueDisplay={handleSummaryMenueDisplay} marketingPlayId={obj.marketingPlayId} campaignSelection={campaignSelection} menuSetting={menuSetting} setMenuSetting={setMenuSetting} />}
  //                 </div>
  //               </div>
  //             </Accordion.Button>
  //             <Accordion.Body in={arrowSetting[obj.marketingPlayId]}>
  //               <Card.Body className="overflow-auto p-0">
  //                 {
  //                   <ResultsGrid
  //                     searchText={searchText}
  //                     filteredDetail={filteredDetail}
  //                     handleRemoveDesign={handleRemoveDesign}
  //                     handleUnpublishDesign={handleUnpublishDesign}
  //                     viewReport={viewReport}
  //                     draftDesignToSendWizard={draftDesignToSendWizard}
  //                     preview={preview}
  //                     columnDefs={columnDefs}
  //                   />
  //                 }
  //               </Card.Body>
  //             </Accordion.Body>
  //           </Card>
  //           </>
  //           )
  //         }
  //     })}
  //       {manageCampaignSummary?.filter(a => 
  //       (
  //         (filterSummary == null ||  (a.playName?.toLowerCase() == filterSummary?.filterText.toLowerCase() && filterSummary?.filterType == 1)) &&
  //         (includeNoRevenue || a.revenue > 0) && a.marketingPlayId
  //       ))?.map((obj, index) => {
  //         // setArrowSettingAll(false);
  //         var filteredDetail = manage_campaign_detail && manage_campaign_detail?.details?.filter(a=> 
  //           (filterDetails==null ||  (a.status?.toLowerCase()==filterDetails?.filterText.toLowerCase() && filterDetails?.filterType==2)) && 
  //           a.marketingPlayId == obj.marketingPlayId  && 
  //           ((searchText ==null && searchText=='') || a.name?.toLowerCase().includes(searchText.toLowerCase())) &&
  //           (includeNoRevenue || a.revenue > 0)
  //           );
  //         if((searchText && filteredDetail.length) || !searchText) {
  //           arrowSetting[obj.marketingPlayId] = !!arrowSetting[obj.marketingPlayId];
  //           return ( 
  //           <>
  //             <Card>
  //             <Accordion.Button as={Card.Header} className={`${arrowSetting[obj.marketingPlayId] ? 'active' : ''}`}  eventKey={obj.marketingPlayId}>
  //               <div className='accordion-header' onClick={() => { arrowHandling(obj.marketingPlayId) }}>
  //                 <div className='row w-100 g-0'>
  //                   <div className="chevrons-col col-1">                      
  //                       <div className='arrows pl-2'>
  //                         <span><i className={`fa fa-angle-${arrowSetting[obj.marketingPlayId] ? 'up' : 'down'}`}></i></span>
  //                       </div>                      
  //                   </div>
  //                   <div className="col-6">
  //                     <div className={'d-flex campaign-info ' + (obj.uncategorized ? 'uncategorized' : obj.playCssClass)}>
  //                       <div className='icon'>
  //                         <i className={obj.uncategorized ? 'fa-regular fa-file-lines m-auto' : obj.playIcon + ' m-auto'}></i>
  //                       </div>
  //                       <div className="titles ml-2">
  //                         <div className='secondary-title'>
  //                           {obj.playName} 
  //                           {obj.playSubtitle && (
  //                             <span> - <strong>{obj.playSubtitle}</strong></span>
  //                           )}
  //                         </div>
  //                         {/* <div className='primary-title'>
  //                           {obj.subtitle}
  //                         </div> */}
  //                       </div>
  //                     </div>
  //                   </div>

  //                   <div className={isESPRole ? "col-3" : "col-5"}>
  //                     <div className="c-revenue text-right">
  //                       {/* {index === 0 && (<div className='total-reven-heading position-absolute secondary-title numeric-data text-muted'>
  //                         Total Revenue
  //                       </div>)} */}
  //                       <div className='primary-title green'>
  //                         {HelperFunctions.formateNumberbyCommas(obj.revenue, true, 0, true)}
  //                       </div>
  //                     </div>
  //                   </div>
  //                   {isESPRole && <ActionButton handleSummaryMenueDisplay={handleSummaryMenueDisplay} marketingPlayId={obj.marketingPlayId} campaignSelection={campaignSelection} menuSetting={menuSetting} setMenuSetting={setMenuSetting} />}
  //                 </div>
  //               </div>
  //             </Accordion.Button>
  //             <Accordion.Body in={arrowSetting[obj.marketingPlayId]}>
  //               <Card.Body className="overflow-auto p-0">
  //                 {
  //                   <ResultsGrid
  //                     searchText={searchText}
  //                     filteredDetail={filteredDetail}
  //                     handleRemoveDesign={handleRemoveDesign}
  //                     handleUnpublishDesign={handleUnpublishDesign}
  //                     viewReport={viewReport}
  //                     draftDesignToSendWizard={draftDesignToSendWizard}
  //                     preview={preview}
  //                     columnDefs={columnDefs}
  //                   />
  //                 }
  //               </Card.Body>
  //             </Accordion.Body>
  //           </Card>
  //           </>
  //           )
  //         }
  //     })}
  //     </>
  //   )
  // :  
  //   <div className='accordion-header'>
  //     <div className='col-12 d-flex justify-content-center'>
  //       <span>No Rows To Show</span>
  //     </div>
  //   </div>;

  return (
    <>
      {HelperFunctions.validateClientUserClaims(
        [componentsClaimKey.Designs, componentsClaimKey.MarketingPlayConfiguration],
        claimOperations.Read,
        clientUserClaims
      ) ?
        <div className='manage-campaigns-page'>
          <div className="row header-section">
            <div className="col-lg-12">
              <div className="campaign-heading-div header pb-3 pt-45 d-flex justify-content-between align-items-center">
                <div>
                  <h1 className='title-heading'>Campaigns</h1>

                </div>
                <div>
                  {HelperFunctions.validateClientUserClaims(
                    [componentsClaimKey.Designs, componentsClaimKey.MarketingPlayConfiguration],
                    claimOperations.Create,
                    clientUserClaims
                  ) ?
                    <>
                      <button className='btn-dark-blue' onClick={() => props.router.navigate("/createNewCampaign")}>
                        New Campaign
                      </button>
                    </> : null}
                </div>
              </div>

            </div>

            <div className="revenue-boxes-div revenue-boxes row m-0 w-100 mb-4 mt-4">
              <div className="col-4">
                <div className="revenue-box">
                  <div className="revenue-heading mb-1 text-muted">
                    Total Revenue
                  </div>
                  <div className="revenue-value">
                    <h6 className="sub-heading">{HelperFunctions.formateNumberbyCommas(totalCategorizedRevenue + totalAdhocRevenue, true)}</h6>
                  </div>
                </div>
              </div>
              <div className="col-4">
                <div className="revenue-box">
                  <div className="revenue-heading mb-1 text-muted">
                    Categorized Revenue
                  </div>
                  <div className="revenue-value">
                    <h6 className="sub-heading">{HelperFunctions.formateNumberbyCommas(totalCategorizedRevenue, true)}</h6>
                  </div>
                </div>
              </div>
              <div className="col-4">
                <div className="revenue-box">
                  <div className="revenue-heading mb-1 text-muted">
                    Uncategorized Revenue
                  </div>
                  <div className="revenue-value">
                    <h6 className="sub-heading">{HelperFunctions.formateNumberbyCommas(totalAdhocRevenue, true)}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="position-relative">
            <Tabs
              className="manage-campaign-tabs tabs-collapse"
              defaultValue="Results"
              onValueChange={setSelectedTabDetail}
            >
              <TabsList>
                <TabsTrigger value="Results">Results</TabsTrigger>
                <TabsTrigger value="TableView">Table View</TabsTrigger>
              </TabsList>
              <TabsContent value="Results">
                <div className="results-sticky-header">
                  <div className="gap-filler" />
                  <div className="parent-filter-div" style={{ zIndex: 1040 }}>
                    <div className="result-tab-div s-collapse row filters-section manage-campaign py-0">
                      <div className="col-lg-12">
                        <div className="campaign-filters d-flex justify-content-between">
                          {/* Expand/Collapse toggle control */}
                          <div className="d-inline-flex">
                            <div className="expand-collapse-controls d-flex align-items-center">
                              <div
                                className="sort-filter cursor-pointer d-flex align-items-center mx-2"
                                onClick={handleExpandCollapseToggle}
                                title={arrowSettingAll ? "Collapse All" : "Expand All"}
                              >
                                <i className={`mr-1 fa fa-${arrowSettingAll ? 'minus' : 'plus'}`} />
                                <label className="campaign-type-select-label text-nowrap mb-0 mr-2">
                                  {arrowSettingAll ? 'Collapse All' : 'Expand All'}
                                </label>
                              </div>
                            </div>
                          </div>
                          {/* Search + checkbox */}
                          <div className="d-inline-flex">
                            <div className="search-field">
                              <label htmlFor="search-bar" className="input-style mb-0">
                                <input
                                  className="searchbar-input w-100"
                                  id="search-bar"
                                  name="searchValue"
                                  type="search"
                                  onChange={searchHandleChange}
                                  value={searchText}
                                  placeholder="Search..."
                                />
                              </label>
                            </div>
                            <div className="sort-filter d-flex align-items-center mx-2">
                              <input
                                className="mr-1"
                                type="checkbox"
                                defaultChecked={includeNoRevenue}
                                onClick={onChangeIncludeNoRevenue}
                                id="chkIncludeNoRevenue"
                              />
                              <label htmlFor="chkIncludeNoRevenue" className="sort-by-label text-nowrap mb-0 mr-2">
                                Include Rows with No Revenue
                              </label>
                            </div>
                          </div>

                          {/* Date Picker + Manage Columns */}
                          <div className="d-inline-flex">
                            <div className="campaigns-date-filter d-flex align-items-center">
                              <label className='date-select-label m-0'>Date: </label>
                              <DatePickerDropDown
                                selectedIndex={3}
                                onFilterChange={handleFilterChangeHandler}
                              />
                            </div>
                            {/* <div className="sort-filter cursor-pointer d-flex align-items-center edit-columns mx-2">
                              <button
                                type="button"
                                onClick={() => {
                                  if (masterDetailGridRef.current?.openManageColumns) {
                                    masterDetailGridRef.current.openManageColumns();
                                  }
                                }}
                              >
                                <span>Manage Columns</span>
                              </button>
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Scrollable campaigns area */}
                <div className="campaigns-scrollable">
                  <div className="campaigns-section row">
                    <div className="col-lg-12">
                      <MasterDetailGrid
                        ref={masterDetailGridRef}
                        manageCampaignSummary={manageCampaignSummary}
                        manageCampaignDetail={manageCampaignDetail}
                        searchText={searchText}
                        includeNoRevenue={includeNoRevenue}
                        filterSummary={filterSummary}
                        filterDetails={filterDetails}
                        sortValue={sortValue}
                        isESPRole={isESPRole}
                        handleRemoveDesign={handleRemoveDesign}
                        handleUnpublishDesign={handleUnpublishDesign}
                        viewReport={viewReport}
                        draftDesignToSendWizard={draftDesignToSendWizard}
                        preview={preview}
                        toggleCampaignSelection={toggleCampaignSelection}
                        campaignSelection={campaignSelection}
                        handleSummaryMenueDisplay={handleSummaryMenueDisplay}
                        menuSetting={menuSetting}
                        setMenuSetting={setMenuSetting}
                        detailColumnDefs={columnDefs}
                        setDetailColumnDefs={handleSetColumnDefs}
                      />
                    </div>
                  </div>
                </div>
              </TabsContent>

              <TabsContent value="TableView">
                <TableViewComponent
                  key={tableViewKey}
                  ref={tableViewRef}
                  searchText={searchText}
                  handleRemoveDesign={handleRemoveDesign}
                  handleUnpublishDesign={handleUnpublishDesign}
                  startDate={startDate}
                  endDate={endDate}
                  viewReport={viewReport}
                  draftDesignToSendWizard={draftDesignToSendWizard}
                  toggleCampaignSelection={toggleCampaignSelection}
                  preview={preview}
                  columnDefs={columnDefs}
                  setColumnDefs={handleSetColumnDefs}
                />
              </TabsContent>
            </Tabs>
          </div>



          <DesignUnpublishModal
            isAdhoc={isAdhoc}
            isUnPublishPopupShow={isUnPublishPopupShow}
            toggleUnPublishPopup={toggleUnPublishPopup}
            design={selectedDesign}
            isFromManageCampaigns={true}
            clientId={clientId}
          />

          {/* Preview Modal */}
          <Dialog open={isPreviewPopupShow} onOpenChange={(open) => { if (!open) togglePreview(); }}>
            <DraggableDialogContent size="lg" id="custom-modal-warning-v1" className="preview-modal-size">
              <DialogHeader className="modal-header">
                <DialogTitle>
                  <div>Preview</div>
                </DialogTitle>
              </DialogHeader>
              <div
                id="design-preview"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                }}
              >
                <div style={{ width: "100%" }}>
                  <iframe
                    srcDoc={previewHTML}
                    style={{
                      width: "100%",
                      height: "80vh",
                      border: "none",
                      overflow: "auto",
                    }}
                  />
                </div>
              </div>
              <DialogFooter>
                <div className="align-middle d-flex w-100 justify-content-between">
                  {publicPreviewLink ? (
                    <div className="w-50">
                      <div>Public Preview Link</div>
                      <div className="d-flex align-middle gap-3">
                        <input
                          type="text"
                          value={publicPreviewLink}
                          readOnly
                          className="form-control"
                        />
                        <button
                          onClick={copyPreviewLink}
                          className="btn btn-link p-0 ml-2 text-primary d-flex flex-column align-items-center text-decoration-none"
                          style={{ boxShadow: "none" }}
                          type="button"
                        >
                          <FaCopy />
                          <span className="mt-2">Copy</span>
                        </button>
                      </div>
                      <button
                        onClick={revokePublicPreviewLinkHandler}
                        disabled={isRevokingLink}
                        className="p-0 font-weight-normal cursor-pointer border-0"
                        style={{
                          backgroundColor: "transparent",
                          color: "#F28989",
                        }}
                      >
                        <i
                          style={{ color: "#F28989" }}
                          className="fa-solid fa-link-slash mr-2 cursor-pointer"
                        ></i>
                        {isRevokingLink
                          ? "Revoking..."
                          : showRevokeConfirm
                            ? "Click to Confirm"
                            : "Revoke"}
                      </button>
                    </div>
                  ) : (
                    <button
                      onClick={() => {
                        generatePublicPreviewLinkHandler(selectedDesign?.templateID);
                      }}
                      disabled={isGeneratingLink}
                      className="w-25 align-middle btn-cancel"
                      style={{
                        cursor: isGeneratingLink
                          ? "not-allowed"
                          : "pointer",
                      }}
                    >
                      {isGeneratingLink
                        ? "Generating..."
                        : "Generate Public Preview Link"}
                      <i className="fa-solid ml-1 fa-link"></i>
                    </button>
                  )}
                  {/* Right side - existing buttons */}
                  <div className="d-flex gap-3 align-items-center">
                    <Button variant="outline" onClick={() => { togglePreview(); }}>Close</Button>
                  </div>
                </div>
              </DialogFooter>
            </DraggableDialogContent>
          </Dialog>

          {/* Move Modal */}
          <Dialog open={isSelectCampaignPopupShow} onOpenChange={(open) => { if (!open) toggleCampaignSelection(); }}>
            <DraggableDialogContent size="md" id="custom-modal-warning-v1" className="move-campaign-modal">
              <DialogHeader className="modal-header">
                <DialogTitle>
                  <div style={{ fontFamily: 'Omnes, sans-serif' }}>Move</div>
                </DialogTitle>
              </DialogHeader>
              <div className="text-left" style={{ fontFamily: 'Omnes, sans-serif' }}>
                {
                  <CampaignSelection
                    isPopupDisplay={true}
                    handleSelectedCampaignId={handleSelectedCampaignId}
                    selectedDesign={selectedDesign}
                  />
                }
              </div>
              <DialogFooter>
                <div className="d-flex justify-content-end gap-3">
                  <Button variant="outline" onClick={() => { toggleCampaignSelection(); }} style={{ fontFamily: 'Omnes, sans-serif' }}>Close</Button>
                  {selectedCampaignId != 0 ? (
                    <Button
                      onClick={() => { onSelectCampaign(); }}
                      style={{
                        fontFamily: 'Omnes, sans-serif',
                        backgroundColor: '#007bff',
                        borderColor: '#007bff',
                        color: 'white'
                      }}
                    >
                      Move
                    </Button>
                  ) : null}
                </div>
              </DialogFooter>
            </DraggableDialogContent>
          </Dialog>
        </div>
        : null}
    </>
  )
}

export default withRouter(ManageCampaigns);
